import { SelectionStats, Survey } from "../../DTOs";
import { surveyHelper, surveyReportHelper } from "../../helpers";
import { QuestionStats } from "./QuestionStats";


export class IndicatorReport
{
    public data:{
        indicator:string,
        selections:SelectionStats
    }[];

    constructor(
        survey:Survey,
        questionReports:QuestionStats[]
    ){
        this.data = [];
        const allQuestions = surveyHelper.getAllSurveyQuestions(survey);
        for(let i=0; i<allQuestions.length; i++){
            const surveyQuestion = allQuestions[i].question;
            const questionReport = questionReports[i];
            const surveyQuestionIndicators = surveyQuestion.indicators;
            if(JSON.stringify(surveyQuestionIndicators.sort()) !== JSON.stringify(questionReport.indicators.sort()))
                throw new Error(`Mismatch in survey question- and report indicators: ${surveyQuestionIndicators.sort().join(',')} | ${questionReport.indicators.sort().join(',')}`);

            for(const indicator of surveyQuestionIndicators){

                let existingDataItem = this.data.find(d => d.indicator === indicator);
                
                if(existingDataItem === undefined)
                    this.data.push(existingDataItem = { indicator, selections:new SelectionStats(surveyReportHelper.createNewSelectionSummary()) });

                const newSelection = questionReports[i].selections;

                existingDataItem.selections =
                        SelectionStats.aggregate(
                            existingDataItem.selections.data, 
                            newSelection.data
                        );
                
            }
        }
    }
}